module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Barbara Pym\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Barbara Pym (1913–1980) was a bestselling and award-winning English novelist. Her first book, "), _c('I', [_vm._v("Some Tame Gazelle ")]), _vm._v("(1950), launched her career as a writer beloved for her social comedies of class and manners. Pym is the only author to be named twice in a "), _c('I', [_vm._v("Times")]), _c('I', [_vm._v("Literary Supplement")]), _vm._v(" list of “the most underrated novelists of the century.” She produced thirteen novels, the last three published posthumously. Her 1977 novel "), _c('I', [_vm._v("Quartet in Autumn ")]), _vm._v("was shortlisted for the Booker Prize.      ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zJJprl/tc-custom/9781453279625.jpg?1733111694357",
      "alt": "This image is the cover for the book No Fond Return of Love"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("No Fond Return of Love\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Three lonely people come together in this poignant, witty novel of star-crossed romance from the "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author of "), _c('i', [_vm._v("Jane and Prudence")]), _vm._v(".")]), _c('br'), _vm._v("  After being jilted by her fiancé, Dulcie Mainwaring despairs of ever finding true love. For a distraction, she goes to a publishing conference, where she meets Viola Dace, a dramatic woman who refuses to live without romance, as well as Aylwin Forbes, an editor whom Viola adores. The fact that Aylwin is married doesn’t stop Viola. When her amorous pursuit prompts Aylwin’s wife to leave him, the academic heartthrob is wide open to Viola’s romantic attentions. That is, until Dulcie’s eighteen-year-old niece moves in with Viola, and the young girl soon catches Aylwin’s roving eye. Set in London in the early 1960s, "), _c('i', [_vm._v("No Fond Return of Love ")]), _vm._v("is a delightful comedy of manners that comes full circle as Dulcie discovers a love as unexpected as it is liberating. \n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0